import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "auth-wrapper" }
const _hoisted_2 = { class: "auth-main d-flex align-items-center justify-content-center" }
const _hoisted_3 = { class: "card shadow-sm border-0 auth-card" }
const _hoisted_4 = { class: "auth-card-grid" }
const _hoisted_5 = { class: "form-column" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-success py-2 text-center"
}
const _hoisted_7 = {
  key: 1,
  class: "alert alert-danger py-2 text-center"
}
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppFooter = _resolveComponent("AppFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[10] || (_cache[10] = _createStaticVNode("<aside class=\"security-column\" data-v-4bd8f97f><span class=\"security-kicker\" data-v-4bd8f97f>Conseils de sécurité</span><h2 class=\"security-title\" data-v-4bd8f97f>Protégez l’accès à votre stock</h2><ul class=\"security-list\" data-v-4bd8f97f><li data-v-4bd8f97f><span class=\"security-icon\" data-v-4bd8f97f><i class=\"fa-solid fa-shield-halved\" data-v-4bd8f97f></i></span><span data-v-4bd8f97f>Évitez d’utiliser le même mot de passe que sur d’autres sites.</span></li><li data-v-4bd8f97f><span class=\"security-icon\" data-v-4bd8f97f><i class=\"fa-solid fa-key\" data-v-4bd8f97f></i></span><span data-v-4bd8f97f>Utilisez au moins 12 caractères, avec une majuscule, une minuscule, un chiffre et un symbole.</span></li><li data-v-4bd8f97f><span class=\"security-icon\" data-v-4bd8f97f><i class=\"fa-solid fa-user-lock\" data-v-4bd8f97f></i></span><span data-v-4bd8f97f>Gardez ce mot de passe privé, même entre utilisateurs de la boutique.</span></li></ul></aside>", 1)),
          _createElementVNode("section", _hoisted_5, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-center mb-4" }, [
              _createElementVNode("img", {
                src: _imports_0,
                class: "auth-logo",
                alt: "Suite241 Gestion Commerciale"
              }),
              _createElementVNode("h3", { class: "fw-bold mb-1" }, "Sécurisez votre compte"),
              _createElementVNode("p", { class: "text-muted mb-0" }, " Vous devez changer le mot de passe par défaut avant d’utiliser Suite241 Gestion Commerciale. ")
            ], -1)),
            (_ctx.successMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.successMessage), 1))
              : _createCommentVNode("", true),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("form", {
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleChangePassword && _ctx.handleChangePassword(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Mot de passe actuel", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.current_password) = $event)),
                  type: "password",
                  class: "form-control form-control-lg",
                  placeholder: "Entrez votre mot de passe actuel",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.form.current_password]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Nouveau mot de passe", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.new_password) = $event)),
                  type: "password",
                  class: "form-control form-control-lg",
                  placeholder: "Choisissez un nouveau mot de passe",
                  minlength: "12",
                  maxlength: "72",
                  autocomplete: "new-password",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.form.new_password]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Confirmer le nouveau mot de passe", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.new_password_confirmation) = $event)),
                  type: "password",
                  class: "form-control form-control-lg",
                  placeholder: "Répétez le nouveau mot de passe",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.form.new_password_confirmation]
                ])
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary btn-lg w-100",
                disabled: _ctx.isLoading
              }, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("i", {
                        class: "fa fa-spinner fa-spin me-2",
                        "aria-hidden": "true"
                      }, null, -1),
                      _createTextVNode("Enregistrement…", -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_13, [...(_cache[8] || (_cache[8] = [
                      _createElementVNode("i", {
                        class: "fa fa-check me-2",
                        "aria-hidden": "true"
                      }, null, -1),
                      _createTextVNode("Valider et continuer", -1)
                    ]))]))
              ], 8, _hoisted_11)
            ], 32)
          ])
        ])
      ])
    ]),
    _createVNode(_component_AppFooter)
  ]))
}